export default __webpack_public_path__ + "static/media/page1.711eec8e.png";